export default "__VITE_ASSET__bH2RvnVG__"